import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

interface Props {
  analysis: string | null;
  isLoading: boolean;
  error: string | null;
}

const AnalysisResult: React.FC<Props> = ({ analysis, isLoading, error }) => {
  if (isLoading) {
    return (
      <div className="w-full max-w-2xl mx-auto p-6">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <LoadingSpinner />
          <p className="text-gray-600 mt-4">Analyzing your stocks...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full max-w-2xl mx-auto p-6">
        <div className="bg-red-50 border border-red-200 rounded-lg shadow-lg p-8">
          <div className="flex items-center mb-4">
            <span className="text-2xl mr-3">❌</span>
            <h3 className="text-lg font-bold text-red-800">Error</h3>
          </div>
          <p className="text-red-700">{error}</p>
          <p className="text-sm text-red-600 mt-4">
            Please try again or contact support if the issue persists.
          </p>
        </div>
      </div>
    );
  }

  if (!analysis) {
    return null;
  }

  return (
    <div className="w-full max-w-2xl mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <h3 className="text-xl font-bold text-gray-800 mb-6">
          Analysis Result
        </h3>
        <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded">
          <div className="prose prose-sm max-w-none">
            {analysis.split("\n").map((line, index) => (
              <p key={index} className="text-gray-700 mb-4 leading-relaxed">
                {line}
              </p>
            ))}
          </div>
        </div>
        <p className="text-xs text-gray-400 mt-6">
          Analysis generated by Google Gemini AI • {new Date().toLocaleString()}
        </p>
      </div>
    </div>
  );
};

export default AnalysisResult;
